import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { Particles } from './ui/Particles';
import { useIsMobile } from '../hooks/useIsMobile';
export function OfferSection() {
  const isMobile = useIsMobile();
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return;
}